<template>
  <div ref="content" class="content">
    <div id="w-editor-content-view" v-if="detail" v-html="detail.content"></div>
  </div>
</template>

<script>
// plugins
import eventBus from "@/plugins/eventBus";

export default {
  name: "DetailThridContent",
  props: {
    contentData: {
      type: Object,
      default: () => null
    }
  },
  data() {
    return {
      detail: {}
    };
  },
  created() {
    // 设置内容
    if (this.contentData && this.contentData.id > 0) {
      this.setDetailContent(this.contentData);
    }
  },
  mounted() {
    // 监听历史记录内容切换
    eventBus.$on("setDetailContent", this.setDetailContent);
  },
  methods: {
    // 设置内容
    setDetailContent(detail) {
      this.detail = detail;
    }
  }
};
</script>

<style lang="less">
#w-editor-content-view {
  // 默认背景颜色
  background-color: #fff;
  // 默认文字颜色
  color: #333;

  // 段落
  p {
    line-height: 1.5;
    margin: 15px 0;
  }

  // 行级span
  span {
    text-indent: 0;
  }

  // 图片
  img {
    cursor: default;
    display: inline !important;
    max-width: 100%;
    min-height: 20px;
    min-width: 20px;
  }

  // video
  [data-w-e-type="video"] {
    margin: 10px auto 0;
    padding: 10px 0;
    text-align: center;
    & > video {
      width: 100% !important;
    }
    & > iframe {
      width: 100% !important;
      height: 450px;
    }
  }
}
</style>
